module.exports = __webpack_public_path__ + "img/topback.148778a0.png";